import rooms from './modules/rooms';
// import synchronisations from './modules/synchronisations';
import referencials from './modules/referencials';
import ward from './modules/ward';
import aroundTheWorld from './modules/aroundTheWorld';

const menu = [ward, rooms,  referencials, aroundTheWorld];

export default menu;
